import { lazy } from 'react';

export const OrderAddItemPageAsync = lazy(() => import('./OrderAddItemPage'));
